import React from 'react';

import { ELEMENT_TYPES } from '../../../core/documentSchema';
import { useMediaStudio } from '../../../context/MediaStudioContext';
import AlignSection from '../components/align-section/AlignSection';
import AppearanceSection from '../components/appearance-section/AppearanceSection';
import FiltersSection from '../components/filters-section/FiltersSection';
import ShapeSection from '../components/shape-section/ShapeSection';
import TransformSection from '../components/transform-section/TransformSection';

const useInspectorSections = () => {
  const { features, selectedElement: element, selectedElements } = useMediaStudio();

  if (!element || !features.inspector) {
    return [];
  }

  if (selectedElements.length > 1) {
    return [
      features.opacityBlend && <AppearanceSection key='appearance' element={element} elements={selectedElements} />,
      features.align && <AlignSection key='align' element={element} elements={selectedElements} />,
    ].filter(Boolean);
  }

  const editable = !element.locked;
  const isShape = element.type === ELEMENT_TYPES.SHAPE;
  const isImage = element.type === ELEMENT_TYPES.IMAGE;

  return [
    features.transform && editable && <TransformSection key='transform' element={element} />,
    features.opacityBlend && <AppearanceSection key='appearance' element={element} />,
    isShape && editable && <ShapeSection key='shape' element={element} />,
    isImage && features.filters && <FiltersSection key='filters' element={element} />,
    features.align && editable && <AlignSection key='align' element={element} />,
  ].filter(Boolean);
};

export default useInspectorSections;
